<form [formGroup]="form">
  <ix-select
    *ngIf="hasSignedBy"
    formControlName="signedby"
    [label]="'Signing Certificate Authority' | translate"
    [required]="true"
    [options]="signingAuthorities$"
    [tooltip]="helptext.add.signedby.tooltip | translate"
  ></ix-select>

  <ix-select
    formControlName="key_type"
    [label]="'Key Type' | translate"
    [required]="true"
    [options]="keyTypes$"
    [tooltip]="helptext.add.key_type.tooltip | translate"
  ></ix-select>

  <ix-select
    *ngIf="isRsa"
    formControlName="key_length"
    [label]="'Key Length' | translate"
    [required]="true"
    [options]="keyLengths$"
    [tooltip]="helptext.add.key_length.tooltip | translate"
  ></ix-select>

  <ix-select
    *ngIf="!isRsa"
    formControlName="ec_curve"
    [label]="'EC Curve' | translate"
    [required]="true"
    [options]="ecCurves$"
    [tooltip]="helptext.add.ec_curve.tooltip | translate"
  ></ix-select>

  <ix-select
    formControlName="digest_algorithm"
    [label]="'Digest Algorithm' | translate"
    [required]="true"
    [options]="digestAlgorithms$"
    [tooltip]="helptext.add.digest_algorithm.tooltip | translate"
  ></ix-select>

  <ix-input
    *ngIf="hasLifetime"
    formControlName="lifetime"
    type="number"
    [label]="'Lifetime' | translate"
    [required]="true"
    [tooltip]="helptext.add.lifetime.tooltip | translate"
  ></ix-input>

  <ix-form-actions>
    <button
      mat-button
      matStepperPrevious
      ixTest="back"
    >{{ 'Back' | translate }}</button>
    <button
      mat-button
      matStepperNext
      color="primary"
      ixTest="next"
      [disabled]="form.invalid"
    >{{ 'Next' | translate }}</button>
  </ix-form-actions>
</form>
